import React, { useState } from 'react';
import styled from 'styled-components';
import OnboardingWelcomeSlide from './OnboardingWelcomeSlide';
import OnboardingImageCarouselIntroduction from './OnboardingImageCarouselIntroduction.jsx';
import jeddleIcon from '../../static/icons/jeddle_icon.png';

// The simplified welcome carousel shown to the three non-school-teacher
// audiences (non-school teacher + school/non-school student). It reuses the
// school teacher's welcome slide + image carousel, parameterised by audience:
//   - 'teacher'  → "AI marking assistant" subtitle + the 6-slide teacher deck
//   - 'student'  → "AI tutor" subtitle + the 3-slide student deck
// On finishing the last slide it calls onFinish (App.jsx launches the wizard).
// Unlike the school flow there is NO close-X — these audiences walk straight
// through carousel → demo tour → plans, matching the Figma flow.

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  /* Same opaque takeover as the school-teacher carousel (index.jsx) — this
     deck has no close-X, so the old 60% scrim left the highlighted sidebar
     and breadcrumbs bleeding through for the entire flow. JeddleCorner below
     already carries z-index 1301, so it stays visible above the backdrop. */
  background-color: rgba(241, 230, 252, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1300;
`;

const ModalContainer = styled.div`
  width: 694px;
  max-width: 90%;
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

const JeddleCorner = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  color: #2e2177;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-family-ibm_plex_sans);
  z-index: 1301;
`;

const JeddleIcon = styled.img`
  width: 26px;
  height: 26px;
`;

const JeddleText = styled.span`
  font-weight: 800;
  font-size: 20px;
`;

const SUBTITLES = {
  teacher: 'Your personalised AI marking assistant',
  student: 'Your personalised AI tutor for instant marking and feedback',
};

const SimpleOnboardingCarousel = ({ audience = 'teacher', onFinish }) => {
  // slide 0 = "Welcome to jeddAI" splash, slide 1 = the image carousel.
  const [slide, setSlide] = useState(0);
  const subtitle = SUBTITLES[audience] || SUBTITLES.teacher;

  return (
    <>
      <Container>
        <ModalContainer>
          {slide === 0 && (
            <OnboardingWelcomeSlide subtitle={subtitle} onNext={() => setSlide(1)} />
          )}
          {slide === 1 && (
            <OnboardingImageCarouselIntroduction
              audience={audience}
              onCloseOnboarding={onFinish}
            />
          )}
        </ModalContainer>
      </Container>
      <JeddleCorner>
        <JeddleIcon src={jeddleIcon} alt="Jeddle" />
        <JeddleText>jeddle</JeddleText>
      </JeddleCorner>
    </>
  );
};

export default SimpleOnboardingCarousel;
